<template>
<article class="form-submission-card">
    <div class="d-flex align-items-center">
        <span class="form-submission-card-content-label mr-2">{{ comment.user?.full_name ?? '(Deleted User)' }}</span>
        <span>{{ comment.submitted_at_formatted }}</span>
    </div>

    <p class="mb-0">{{ comment.comment }}</p>
</article>
</template>

<script>
export default {
    name: 'Comment',

    props: {
        comment: Object
    }
}
</script>
